import React from 'react';
import  {assets_root, lorem} from './Helpers';
import Chart from './Chart';
import {Divider} from 'semantic-ui-react';
import Context from './Context';

function Content(props) {
  return (
    <Context.Consumer>
     {({width, step, indicator}) => (
        <div className="App">
          <div className="intro">
            <section data-step="0">
              <p><strong>Scroll down</strong> as we examine the trajectories of the two recessions and recoveries, comparing them side-by-side.</p>
            </section>
          </div>
          <div className="well" >
            <div className="contain">
              <div className="sections">
                <section data-step='1'><h4>Unemployment in the Great Recession and recovery</h4><p>The Great Recession lasted from December 2007 to June 2009. The unemployment rate climbed sharply and neared post-World War II record highs by 2010. A steady improvement followed, and the unemployment rate fell below 4% by 2019, 10 years after the end of the recession. Levels that low were last observed in the 1960s.</p></section>
                { width < 720 ?
                  <div className="graphic">
                   <Chart ui={false} lockIndicator={'unemployment-rate'} lockDemographic={'all'} lockStep={1}/>
                  </div>
                : null }
                <section data-step='2'><h4>Unemployment in the 1990-1991 recession and recovery</h4><p>The recession from July 1990 to March 1991 was short-lived and relatively mild. The unemployment rate increased by about 2 percentage points, peaking in 1992. Following a gradual decline, it settled a bit above 4% by the end of the recovery in 2001.</p></section>
                { width < 720 ?
                  <div className="graphic">
                   <Chart ui={false} lockIndicator={'unemployment-rate'} lockDemographic={'all'} lockStep={2}/>
                  </div>
                : null }
                <section data-step='3'><h4>Unemployment in the two recessions and recoveries</h4><p>The unemployment rate in the Great Recession showed a more extreme rise than in the 1990-1991 recession, followed by a steeper decline in the recovery. It settled below 4% for most months in 2019, dipping to levels not observed in the decade following the 1990-1991 recession.</p></section>
                { width < 720 ?
                  <div className="graphic">
                   <Chart ui={false} lockIndicator={'unemployment-rate'} lockDemographic={'all'} lockStep={3}/>
                  </div>
                : null }
              </div>
              { width >= 720 ?
                <div className="graphic sticky">
                 <Chart ui={false} lockIndicator={'unemployment-rate'} lockDemographic={'all'}/>
                </div>
              : null }
            </div>
            <div className="contain" style={{flexDirection: 'column'}}>
              <div className="sections" style={{width:'100%', marginLeft: 0, marginRight: 0 }}>
                <section data-step='4'><p><strong>Explore the interactive below</strong> to view other dimensions of the recessions and recoveries. Select an economic indicator and a demographic group to see how the two recessions and the first 10 years of each recovery affected American workers and households. See <a href="#terminology">Terminology</a> and <a href="#methodology">Methodology</a> for details.</p></section>
                </div>
                <div className="graphic" style={{width: "100%"}}>
                 <Chart ui={true} />
               </div>
               <div class="note">
                 { ~['unemployment-rate', 'employment-rate', 'labor-force-participation'].indexOf(indicator) ? <p>Note: Estimates for 1989-2001 are for the first quarter of each year and estimates for 2007-2019 are for the second quarter of each year, non-seasonally adjusted.</p> :
                 <p>Note: Annual income is adjusted for household size and scaled to a three-person household. Estimates in 2018 dollars. Data for 2019 are not yet available.</p> }
                 { ~['unemployment-rate', 'employment-rate', 'labor-force-participation'].indexOf(indicator) ? <p>Source: Pew Research Center analysis of 1989 to 2001 and 2007 to 2019 Current Population Survey monthly files (IPUMS).</p> :
                 <p>Source: Pew Research Center analysis of the 1990 to 2001 and 2008 to 2019 Current Population Survey Annual Social and Economic Supplement (IPUMS).</p> }

               </div>
          </div>
        </div>
        </div>
      )}
      </Context.Consumer>
  );
}

export default Content;
